// pages/StructurePage.jsx

import React, { useState } from 'react';
import DivisionsTab from './publicTabs/DivisionsTab';
import RanksTab from './publicTabs/RanksTab';

function StructurePage() {

  const [currentTab, setCurrentTab] = useState('divisions'); // Gérer l'onglet actuellement sélectionné

  return (
    <div>
        <div className="title-container margin-top-spacer-60">
            {/* Onglets cliquables */}
            <div onClick={() => setCurrentTab('divisions')} className={`trapezoid-border3 ${currentTab === 'divisions' ? 'active' : ''}`}>
                <a className="trapezoid-title">
                    <span>Divisions</span>
                </a>
            </div>
            <div onClick={() => setCurrentTab('ranks')} className={`trapezoid-border3 ${currentTab === 'ranks' ? 'active' : ''}`}>
                <a className="trapezoid-title">
                    <span>Ranks</span>
                </a>
            </div>
        </div>
        <div className='public-container glass-card' >
            {/* Conditionnellement rendre les onglets basés sur l'état `currentTab` */}
            {currentTab === 'divisions' ? <DivisionsTab /> : <RanksTab />}
        </div>
    </div>
  );

}

export default StructurePage;
